const { REACT_APP_BUCKET: BUCKET, REACT_APP_STAGE: STAGE } =
  process.env as Record<string, string>;

export { BUCKET, STAGE };
